function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.937 0l.806 2.992 2.992.805-2.992.806-.806 2.992-.805-2.992L.14 3.797l2.992-.805L3.937 0z",
  fill: "#00CCBC"
});
function SvgStarMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 8",
    fill: "none"
  }, props), _ref);
}
export default __webpack_public_path__ + "fonts/star-medium-c3841610c6bdae471c295ff747bae969.svg";
export { SvgStarMedium as ReactComponent };